import { render, staticRenderFns } from "./cmpgeralinkrillpay.vue?vue&type=template&id=63a22c77&"
import script from "./cmpgeralinkrillpay.vue?vue&type=script&lang=js&"
export * from "./cmpgeralinkrillpay.vue?vue&type=script&lang=js&"
import style0 from "./cmpgeralinkrillpay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports